import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "_bxsh--base _rounded--common _bgc--white _fo",
  role: "list"
}
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = ["href", "data-qa"]
const _hoisted_4 = {
  class: "_grow-1 _fw-b _tc--dark",
  "data-qa": "box-list-subitem-name"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_collapsible = _resolveComponent("base-collapsible")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
      return (_openBlock(), _createBlock(_component_base_collapsible, {
        key: `item-${item.name}`,
        "model-value": $data.openKey === item.name,
        "is-controlled": "",
        role: "listitem",
        "onUpdate:modelValue": val => $options.onToggle(item.name, val),
        "data-qa": `box-list-item:${item.name}`
      }, {
        trigger: _withCtx(({ isExpanded }) => [
          _createElementVNode("div", {
            class: "_pa-2 _w-100 _bdb--thick _bc--light _flex _ai-c",
            "aria-expanded": isExpanded
          }, [
            _createVNode(_component_base_icon, {
              name: isExpanded ? 'chevron-down' : 'chevron-right',
              class: "_tc--accent",
              size: "lg",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["name"]),
            _createElementVNode("span", {
              class: _normalizeClass(['_ml-1 _fw-b _tal' , isExpanded ? '_tc--accent' : '_tc--dark']),
              role: "heading",
              "aria-level": "3",
              "data-qa": "box-list-item-name"
            }, _toDisplayString(item.name), 3 /* TEXT, CLASS */)
          ], 8 /* PROPS */, _hoisted_2)
        ]),
        content: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subitem) => {
            return (_openBlock(), _createElementBlock("a", {
              key: subitem.name,
              href: subitem.url,
              class: "_flex _gap-2 _ai-c _pl-7 _pr-2 _py-2 _tdh-n gfu-link gfu-link--nofx _bdb--thick _bc--light",
              "data-qa": `box-list-subitem:${subitem.name}`
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(subitem.name), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "onUpdate:modelValue", "data-qa"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}